import { SIPOC } from '@qpr/sipoc';
import React, { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import AppBarContext from '../components/BusinessPortalAppBarContext';
import sipocViewModel from '../modules/SIPOC/views/sipoc-view-model';

type SipocPageParams = { businessProcessId: string; sipocId?: string };

function SIPOCPage() {
  const appBarContext = useContext(AppBarContext);

  useEffect(() => {
    appBarContext.setAppBar(true);
    appBarContext.setPeriodSelector(false);
  }, [appBarContext]);

  const { businessProcessId, sipocId } = useParams<SipocPageParams>();
  const viewModel = sipocViewModel(businessProcessId, sipocId || '-');
  return <SIPOC SIPOCViewModel={viewModel} />;
}

export default SIPOCPage;
